module.exports = __webpack_public_path__ + "static/media/rumblr.ec2962d4.png";